import React from "react";
import PropTypes from "prop-types";

import classNames from "classnames";

const Main = ({ className, children }) => (
  <div className={classNames("main", className)}>{children}</div>
);

Main.propTypes = {
  className: PropTypes.string,
  children: PropTypes.element,
};

export default Main;
